<div class="slider" *ngIf="sources.length > 1; else justOne">

  <swiper-container class="slider"
  speed="500"
  round-lengths="true"

  [modules]="swiper_modules"
  autoplay-delay="7000"
  pagination-clickable="true"

  autoplay="true"
  pagination="true"
  navigation="true"
  keyboard="true"
  >
    <swiper-slide *ngFor="let source of sources">
      <!-- external link -->
      <a *ngIf="source.link?.startsWith('http')"                [href]="source.link" target="_blank" rel="noreferrer"><img [src]="source.src" [alt]="source.alt || ''"></a>
      <!-- internal link -->
      <a *ngIf="source.link && !source.link.startsWith('http')" [href]="source.link" [routerLink]="source.link"      ><img [src]="source.src" [alt]="source.alt || ''"></a>
      <!-- no link -->
      <img *ngIf="!source.link" [src]="source.src" [alt]="source.alt || ''">
    </swiper-slide>
  </swiper-container>
</div>

<ng-template #justOne>
  <a class="just-one" *ngIf="sources[0]?.link" [href]="sources[0].link" [routerLink]="sources[0].link">
    <img class="just-one" [src]="sources[0].src" [alt]="sources[0].alt ||  ''">
  </a>
  <img class="just-one" *ngIf="sources.length && !sources[0].link" [src]="sources[0].src" [alt]="sources[0].alt ||  ''">
</ng-template>
